import { RetailerNetworkLocationDataFragment } from '@occc/graphql';

import { LocationGeneralInfoCard } from './location-general-info-card.component';

import { useLocationSchedule } from '../location-schedule-card';
import { useLocationAttributes } from '../location-attributes-card';

type LocationGeneralInfoCardContainerProps = {
  location: RetailerNetworkLocationDataFragment;
};

export const LocationGeneralInfoCardContainer = ({
  location,
}: LocationGeneralInfoCardContainerProps) => {
  const scheduleController = useLocationSchedule({ location });
  const attributesController = useLocationAttributes({ location });

  return (
    <LocationGeneralInfoCard
      name={location.name}
      address={location.address}
      phoneNumbers={location.phoneNumbers.map(({ phoneNumber }) => phoneNumber)}
      schedule={scheduleController?.data?.scheduleList}
      attributes={attributesController.data.attributes}
    />
  );
};
